/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDoSeeDataContext } from "../../../context/doSeeData/DoSeeDataContext";
import { pushOneTipsAndAdvice } from "../../../middlewares/sysNavigation/SysNavigation";
import { BreadCrumbComponent } from "../../../middlewares/breadCrumb/BreadCrumbComponent";
import {
  Modal,
  GoBack,
  MySearch,
  MyButton,
  Pagination,
  DashboardIntro,
} from "../../home/component/Component";
import { _TYPES_ } from "../utils/types";
import { _PAGE_SIZE_ } from "../../../middlewares/other/tools";
import { useGeoPositionContext } from "../utils/geoPosition";
import { useAdminContext } from "../../../context/admin/context/AdminContext";
import PromoteContent from "../utils/PromoteContent";
import { FaRegCheckSquare, FaRegSquare, FaRegTrashAlt } from "react-icons/fa";
import { RiRefreshLine } from "react-icons/ri";

const addRoute = "/data/tips/advice/add";
const editRoute = "/data/tips/advice/edit";
const doseeDataRoutes = "/dosee/data";

const Overview = () => {
  const [tipsAndAdviceList, setTipsAndAdviceList] = useState([]);
  const {
    tipsAndAdvice,
    tipsAndAdviceCount,
    fetchDoSeeData,
    deleteOneContent,
  } = useDoSeeDataContext();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(_PAGE_SIZE_);

  const [localSearch, setLocalSearch] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedContentIds, setSelectedContentIds] = useState([]);

  const {
    country_id,
    entry_label,
    first_level_id,
    fourth_level_id,
    second_level_id,
    third_level_id,
  } = useGeoPositionContext();

  const data_request_body = {
    country_id,
    first_level_id,
    second_level_id,
    third_level_id,
    fourth_level_id,
    content: _TYPES_.TIPSANDADVICE,
  };

  useEffect(() => {
    if (!tipsAndAdvice) fetchDoSeeData(data_request_body, page, pageSize);
    setTipsAndAdviceList(tipsAndAdvice);
  }, [tipsAndAdvice]);

  const reloadData = () => fetchDoSeeData(data_request_body, page, pageSize);

  const SearchList = (e) => {
    const key = e.target.value.toString().toLowerCase();
    let searchArray = [];
    tipsAndAdvice.map((taa) => {
      if (taa.title.toString().toLowerCase().includes(key))
        return searchArray.push(taa);
      return true;
    });

    setTipsAndAdviceList(searchArray);
    if (key === "") setTipsAndAdviceList(tipsAndAdvice);
  };

  const LocalData = localSearch?.length > 0 ? localSearch : tipsAndAdviceList;

  const deleteMany = async () => {
    setLoading(true);

    for (let i = 0; i < selectedContentIds.length; i++) {
      await deleteOneContent({
        data_id: selectedContentIds[i],
        content: _TYPES_.TIPSANDADVICE,
      });
    }

    setLoading(false);

    reloadData();
  };

  return (
    <div className="p-3 lg:p-4  h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <BreadCrumbComponent />
      <GoBack props={{ route: doseeDataRoutes }} />
      <div className="my-3">
        <DashboardIntro
          props={{ intro: `Tips And Advice`, name: entry_label }}
        />
      </div>

      <div className="flex flex-col justify-center">
        <MySearch
          type={_TYPES_.TIPSANDADVICE}
          value={localSearch}
          showGlobalSearch={true}
          setValue={setLocalSearch}
          onChange={(e) => SearchList(e)}
        />

        <div className="w-full flex justify-end my-5">
          {country_id ? (
            <Link to={addRoute}>
              <MyButton
                title="Add Tips And Advice"
                className="py-3 px-8 bg-blue-900 hover:bg-blue-600"
                onClick={() => {}}
              />
            </Link>
          ) : null}
        </div>

        <div className="flex items-center">
          <MyButton className="text-black flex items-center space-x-2">
            {selectedContentIds?.length === LocalData?.length ? (
              <FaRegCheckSquare
                onClick={() => setSelectedContentIds([])}
                className="text-green-500 cursor-pointer text-lg"
              />
            ) : (
              <FaRegSquare
                onClick={() => {
                  const ids = LocalData.map(
                    (tips_and_advice) => tips_and_advice?.tips_and_advice_id
                  );
                  setSelectedContentIds(ids);
                }}
                className="cursor-pointer text-black text-lg"
              />
            )}
            <p className="text-black">
              {selectedContentIds.length === LocalData?.length
                ? "Unselect All"
                : "Select All"}
            </p>
          </MyButton>

          <MyButton
            onClick={deleteMany}
            className="text-black flex items-center space-x-2"
          >
            {loading ? (
              <RiRefreshLine className="text-black text-lg animate-spin" />
            ) : (
              <FaRegTrashAlt className="text-red-500 cursor-pointer text-base" />
            )}
            <p className="text-black">
              Delete {selectedContentIds?.length} Item(s)
            </p>
          </MyButton>
        </div>

        <div className="mb-5 overflow-y-auto w-full py-2">
          <table className="table-auto w-full border-collapse border border-gray-300 text-xs text-left">
            <thead>
              <tr className="space-x-2">
                <th className="border p-2 lg:px-4 font-bold w-1/3">Select</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Title</th>
                <th className="border p-2 lg:px-4 font-bold w-1/3">Slug</th>
                <th className="border text-center w-1/3">Action</th>
              </tr>
            </thead>
            <tbody className="space-x-2 text-left border-gray-300">
              {tipsAndAdvice || LocalData ? (
                LocalData?.map((taa, key) => (
                  <tr key={key}>
                    {" "}
                    <td className="border px-2 lg:px-4 w-1/3 text-lg">
                      {selectedContentIds.includes(taa?.tips_and_advice_id) ? (
                        <MyButton
                          onClick={() => {
                            const filteredIds = selectedContentIds.filter(
                              (id) => id !== taa?.tips_and_advice_id
                            );
                            setSelectedContentIds(filteredIds);
                          }}
                        >
                          <FaRegCheckSquare className="text-green-500 cursor-pointer text-lg" />
                        </MyButton>
                      ) : (
                        <MyButton
                          onClick={() =>
                            setSelectedContentIds([
                              ...selectedContentIds,
                              taa?.tips_and_advice_id,
                            ])
                          }
                        >
                          <FaRegSquare className="cursor-pointer text-black text-lg" />
                        </MyButton>
                      )}
                    </td>
                    <td className="border px-2 lg:px-4 w-1/3">{taa?.title}</td>
                    <td className="border px-2 lg:px-4 w-1/3">{taa?.slug}</td>
                    <td className="border w-1/3">
                      <ActionButton props={taa} reloadData={reloadData} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                  <td className="border px-2 lg:px-4 w-1/3">...</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <Pagination
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total_items={tipsAndAdviceCount}
          callbackFunction={(p, size) => {
            fetchDoSeeData(data_request_body, p, size);
          }}
        />
      </div>
    </div>
  );
};

/**
 * @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props, reloadData }) => {
  const { sysAdmin } = useAdminContext();
  const isSuperAdmin = ["super_admin", "admin"].includes(sysAdmin?.role);
  const { tipsAndAdvice, deleteOneContent, updateOneContent } =
    useDoSeeDataContext();

  const [showModal, setShowModal] = useState(false);

  const [promote, setPromote] = useState(false);
  const [promoteLoader, setPromoteLoader] = useState(false);

  const tips_and_advice_id = props.tips_and_advice_id;
  const tipsandadvice_tile = props.title;
  const tipsandadvice = props;

  const deleteOneTipspushOneTipsAndAdviceById = async (tips_and_advice_id) => {
    const { status } = await deleteOneContent({
      data_id: tips_and_advice_id,
      content: _TYPES_.TIPSANDADVICE,
    });

    if (status === 200) {
      reloadData();
    }
  };

  const buildData = (object, position) => {
    return {
      promoted: `${position}`,
      country_id: object?.country_id,
      description: object?.description,
      featured: object?.featured,
      first_level_id: object?.first_level_id,
      fourth_level_id: object?.fourth_level_id,
      hashtag: object?.hashtag,
      second_level_id: object?.second_level_id,
      slug: object?.slug,
      status: object?.status,
      third_level_id: object?.third_level_id,
      thumbnail: object?.thumbnail,
      title: object?.title,
    };
  };

  /**
   *
   * @author Ntavigwa Bashombe
   * @param {*} tipsandadvice
   */
  const promotion = async (position) => {
    const previousPromoted = tipsAndAdvice?.find(
      (tipsandadvice) => tipsandadvice?.promoted === String(position)
    );

    setPromoteLoader(true);

    const { status } = await updateOneContent({
      data_id: tipsandadvice?.tips_and_advice_id,
      data: buildData(props, position),
      content: _TYPES_.TIPSANDADVICE,
    });

    if (previousPromoted) {
      await updateOneContent({
        data_id: previousPromoted?.tips_and_advice_id,
        data: buildData(previousPromoted, "no"),
        content: _TYPES_.TIPSANDADVICE,
      });
    }

    if (status === 200) {
      reloadData();
    }
  };

  const suspension = async (tipsandadvice) => {
    const data = {
      country_id: tipsandadvice?.country_id,
      description: tipsandadvice?.description,
      featured: tipsandadvice?.featured,
      first_level_id: tipsandadvice?.first_level_id,
      fourth_level_id: tipsandadvice?.fourth_level_id,
      hashtag: tipsandadvice?.hashtag,
      promoted: tipsandadvice?.promoted,
      second_level_id: tipsandadvice?.second_level_id,
      slug: tipsandadvice?.slug,
      status: tipsandadvice?.status === 1 ? 0 : 1,
      third_level_id: tipsandadvice?.third_level_id,
      thumbnail: tipsandadvice?.thumbnail,
      title: tipsandadvice?.title,
    };

    const { status } = await updateOneContent({
      data_id: tipsandadvice?.tips_and_advice_id,
      data: data,
      content: _TYPES_.TIPSANDADVICE,
    });

    if (status === 200) {
      reloadData();
    }
  };

  return (
    <>
      <Modal
        props={{
          name: tipsandadvice_tile,
          showModal: showModal,
          setShowModal: () => setShowModal(false),
          delete: () =>
            deleteOneTipspushOneTipsAndAdviceById(tips_and_advice_id),
        }}
      />

      <PromoteContent
        visible={promote}
        setVisible={setPromote}
        loading={promoteLoader}
        ids={tipsAndAdvice
          ?.filter(
            (tips_and_advice) =>
              !["yes", "no", null, undefined].includes(
                tips_and_advice?.promoted
              )
          )
          .map((tips_and_advice) => ({
            id: tips_and_advice?.tips_and_advice_id,
            title: tips_and_advice?.title,
            position: parseInt(tips_and_advice?.promoted),
          }))}
        onClick={(position) => promotion(position)}
      />

      <div className="flex flex-row justify-end items-center px-2 py-3 space-x-4 text-xs">
        {isSuperAdmin ? (
          <>
            <MyButton
              title={tipsandadvice?.status === 1 ? "Suspend" : "Unsuspend"}
              className={`py-3 px-8 ${
                tipsandadvice?.status === 1
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-orange-900 hover:bg-orange-600"
              }`}
              onClick={() => suspension(tipsandadvice)}
            />
            <MyButton
              title={
                ["yes", "no", null, undefined].includes(tipsandadvice?.promoted)
                  ? "Promote"
                  : "Unpromote"
              }
              className={`py-3 px-8 ${
                ["yes", "no", null, undefined].includes(tipsandadvice?.promoted)
                  ? "bg-gray-900 hover:bg-gray-600"
                  : "bg-orange-900 hover:bg-orange-600"
              }`}
              onClick={() => setPromote(true)}
            />
          </>
        ) : null}

        <Link to={editRoute}>
          <MyButton
            title="Edit"
            className={`py-3 px-8 bg-blue-800 hover:bg-blue-600`}
            onClick={() => pushOneTipsAndAdvice(tipsandadvice)}
          />
        </Link>
        <MyButton
          title="Delete"
          className={`py-3 px-8 bg-red-800 hover:bg-red-600`}
          onClick={() => setShowModal(true)}
        />
      </div>
    </>
  );
};

export default Overview;
